import { useMemo } from "react";
import type { NavBadgeConfig } from "@/types/navigation";
import { useNavigationContext } from "./useNavigationContext";

export interface NavBadgeState {
  show: boolean;
  value?: number | string;
  variant?: "default" | "secondary" | "destructive" | "warning";
}

export function useNavBadge(config?: NavBadgeConfig): NavBadgeState {
  const nav = useNavigationContext();

  return useMemo(() => {
    if (!config || nav.loading) {
      return { show: false };
    }

    const metricValue = nav[config.metric];
    if (typeof metricValue !== "number" || metricValue <= 0) {
      return { show: false };
    }

    const value =
      metricValue > 99 ? "99+" : metricValue < 0 ? 0 : Math.round(metricValue);

    return {
      show: true,
      value,
      variant: config.variant ?? "default",
    };
  }, [config, nav]);
}
